import { FormControl, FormGroup } from '@angular/forms';

export type JsonSchemaType = 'string' | 'number' | 'integer' | 'boolean' | 'object' | 'array';

export interface JsonSchemaProperty {
  type?: JsonSchemaType;
  title?: string;
  description?: string;
  default?: unknown;
  enum?: (string | number | boolean)[];
  enumNames?: string[];
  minimum?: number;
  maximum?: number;
  minLength?: number;
  maxLength?: number;
  pattern?: string;
}

export interface SettingsJsonSchema {
  type?: JsonSchemaType;
  title?: string;
  properties?: Record<string, JsonSchemaProperty>;
  required?: string[];
}

export enum DynamicControlType {
  TEXT = 'text',
  NUMBER = 'number',
  TOGGLE = 'toggle',
  SELECT = 'select',
  UNSUPPORTED = 'unsupported',
}

export interface DynamicSelectOption {
  label: string;
  value: string | number | boolean;
}

export interface DynamicFieldDescriptor {
  key: string;
  controlType: DynamicControlType;
  label: string;
  description?: string;
  required: boolean;
  options?: DynamicSelectOption[];
  /** Raw value for fields whose type the renderer cannot edit; shown read-only and preserved on save. */
  rawValue?: unknown;
}

export type DynamicSettingsFormGroup = FormGroup<Record<string, FormControl>>;

export interface DynamicSettingsForm {
  formGroup: DynamicSettingsFormGroup;
  fields: DynamicFieldDescriptor[];
}
